/**
 * Pre-compiled de messages for Avatar
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  avatarLabel: (args: Record<string, string | number>) =>
    `Avatarbild für ${args.fullName}`,
  avatarLabelGeneric: `Generic user avatar`,
};
